<div class="row exercise-template-add-list">
  @for (exc of allTemplateExerciseList(); track exc.id; ) {
    <div class="col-12">
      <div class="exercise-wrapper row g-0">
        <div class="video-wrapper col-12 col-md-auto">
          <sana-tp-therapist-video-viewer
            [videoTitle]="exc.variationName!"
            [videoUrl]="exc.linkToVideo!"
            [vttPath]="'marker/' + exc.markerFileName!">
          </sana-tp-therapist-video-viewer>
        </div>

        <div class="exc-details col-12 col-md">
          <div class="exc-header">
            <div class="title"> {{ exc.title }}</div>
          </div>

          <div class="exc-description">
            <div class="badges">
              <sana-tp-exercise-activity-badge
                [activityType]="exc.activityType"></sana-tp-exercise-activity-badge>

              <div> | </div>

              <sana-tp-joint-badge
                [joints]="exc.joints"></sana-tp-joint-badge>
            </div>

         <!--   <div class="description">
              {{ exc.description }}
            </div>-->
          </div>

          <div class="d-md-flex flex-row justify-content-between mt-auto pt-2 pt-lg-0 align-items-baseline">
            @if (exc.variants.length !== 0) {
              <p-select
                id="exerciseVariants"
                [options]="exc.variants"
                [optionValue]="'id'"
                [dataKey]="'id'"
                placeholder="Variante auswählen"
                size="small"
                [fluid]="true"
                [(ngModel)]="selectedExerciseVariant[exc.aggregateId!]"
                (onChange)="variantSelectionChanged($event)"
                [disabled]="isExerciseAlreadySelected(exc)"
              >

                <ng-template
                    let-selectedEntry
                    #selectedItem>
                  {{ selectedEntry.variationName }}
                </ng-template>

                <ng-template
                    let-entry
                    #item>
                  {{ entry.variationName }}
                </ng-template>
              </p-select>
            }

            <div class="add-to-plan-btn ms-auto">
              @if (isExerciseAlreadySelected(exc)) {
                <p-button
                  class="d-flex justify-content-end"
                  (onClick)="removeFromTherapyPlan(exc)"
                  severity="danger"
                  size="small"
                  icon="pi pi-trash"
                  pTooltip="Entfernt die Übung aus dem Therapieplan"
                  tooltipPosition="left" />
              } @else {
                <p-button
                  class="d-flex justify-content-end"
                  (onClick)="addToTherapyPlan(exc)"
                  severity="primary"
                  size="small"
                  icon="pi pi-plus-circle" />
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  @if (!allTemplateExerciseList() || allTemplateExerciseList()!.length === 0) {
    <p-message severity="error">
      Es wurden keine Übungen zu den ausgewählten Filtern gefunden. Bitte setzen Sie die Filter zurück.
    </p-message>
  }
</div>
